import { render, staticRenderFns } from "./SalesDiscountSummary.vue?vue&type=template&id=2b3bb4a0&"
import script from "./SalesDiscountSummary.vue?vue&type=script&lang=js&"
export * from "./SalesDiscountSummary.vue?vue&type=script&lang=js&"
import style0 from "./SalesDiscountSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports